import { render, staticRenderFns } from "./AppointmentDetail.vue?vue&type=template&id=6ad7a18d&scoped=true&"
import script from "./AppointmentDetail.vue?vue&type=script&lang=js&"
export * from "./AppointmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentDetail.vue?vue&type=style&index=0&id=6ad7a18d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad7a18d",
  null
  
)

export default component.exports